import React from "react";
import '../Common.scss';
import './Elevation3.scss';
import defaultImage from '../../../assets/default.png';
import Image from '../../../components/Image';

export default class ElevationInternals extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const { accessorySpecificationList, elevationImage } = pageDetails || {};
        return (

            <React.Fragment>
                    <div className="page-image-container">
                            <div className="page-heading">{pageDetails?.name}</div>
                            <div className="image-section-container">
                                <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}` : defaultImage} alt="" className="image-view" />
                            </div>
                    </div>
                    <div className="details-tables images-section-internals">
                        {    
                            (accessorySpecificationList && accessorySpecificationList.length)
                            ?accessorySpecificationList.map((imageObj) => {
                                let { accessoryAnnotationId, accessoryName, accessoryImageUrl } = imageObj;
                                const accNameTokens = accessoryName.split('#');
                                const accName = accNameTokens[0];
                                const accNameCat = accNameTokens.length > 1?accNameTokens[1]:'';
                                let imageUrl = '';
                                if(accessoryImageUrl) {
                                    imageUrl = accessoryImageUrl.includes('http')?accessoryImageUrl:`https://diqo3k74ktdb.cloudfront.net${accessoryImageUrl}`;
                                }
                                return (
                                       <div className="internal-image-div">
                                            <p className="internal-heading">{accessoryAnnotationId}</p>
                                            <div className="border-image">
                                                <Image className="internals-image-small" src={imageUrl} />
                                                <p className="image-name">{accName?accName:"name"}</p>
                                                <p className="image-name-subtext">{accNameCat?`#${accNameCat}`:""}</p>
                                            </div> 
                                        </div>
                                          
                                )
                            })
                            :<p className='noAccessoryText'>No Accessories Applied</p>
                        }
                    </div>
            </React.Fragment>
        )
    }

}